import FAQsSection from "../components/views/users/faqs/FAQsSection";
import Hero from "../components/views/users/faqs/Hero";
import GetStarted from "../components/views/users/home/GetStarted";

const FAQs = () => {
  return (
    <div>
      <Hero />
      <FAQsSection />
      <GetStarted />
    </div>
  );
};

export default FAQs;
